import { render, staticRenderFns } from "./shop-product-supplies.vue?vue&type=template&id=5639e918&"
import script from "./shop-product-supplies.vue?vue&type=script&lang=js&"
export * from "./shop-product-supplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports